import { Component, ViewEncapsulation } from '@angular/core';
import {
  ScrollToConfigOptions,
  ScrollToService,
} from '@nicky-lenaers/ngx-scroll-to';

import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-quality-of-life-page',
  templateUrl: './quality-of-life-page.component.html',
  styleUrls: ['./quality-of-life-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QualityOfLifePageComponent {
  constructor(
    config: NgbCarouselConfig,
    private scrollToService: ScrollToService
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;
  }

  triggerScrollTo(target: string) {
    const config: ScrollToConfigOptions = {
      target,
    };
    this.scrollToService.scrollTo(config);
  }
}
